import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { List } from 'components/shared/List/List'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { SheetPreview } from 'components/shared/SheetPreview/SheetPreview'

import { DownloadCloudIcon } from 'components/shared/Icon/model'

import styles from './CandidatesPreview.module.scss'

export const CandidatesPreview = ({
  data,
  onDownloadTemplate,
  onPreview,
  isPreviewOpen,
}) => {
  const count = R.length(data)

  return (
    <Box className={styles.preview} direction="column">
      <List className={styles.actions} tagName="menu">
        <List.Item className={styles.action}>
          <Button
            icon={DownloadCloudIcon}
            label={t`Download template`}
            size="small"
            variant="text"
            onClick={onDownloadTemplate}
          />
        </List.Item>
        <List.Item className={styles.action}>
          <Button
            label={isPreviewOpen ? t`Hide preview` : t`Show preview`}
            size="small"
            variant="text"
            onClick={onPreview}
            isDisabled={!count}
          />
        </List.Item>
      </List>
      {isPreviewOpen ? (
        <>
          <p className={styles.text}>
            {t`You're uploading ${count} candidates listed below:`}
          </p>
          <SheetPreview className={styles.sheet} {...{ data }} />
        </>
      ) : (
        <MessageAlert
          className={styles.alert}
          message={
            R.gt(count, 0)
              ? t`Click “Show preview“ to see the candidates you're uploading.`
              : t`There're no candidates to preview yet.`
          }
          variant="info"
          isInitialised
        />
      )}
    </Box>
  )
}
